import React from 'react';
import { Space, Button, Divider } from 'antd';
import { clear, getArchive, listTasks } from '../actions';
import { seed } from '../seed';

const DebugControls = () => (
    <>
        <Space>
            <Button
                size="small"
                onClick={seed}
            >
                Seed
            </Button>
            <Button
                size="small"
                onClick={clear}
            >
                Clear
            </Button>
            <Button
                size="small"
                onClick={() => getArchive().then(console.log)}
            >
                Archive
            </Button>
            <Button
                size="small"
                onClick={() => listTasks().then(console.log)}
            >
                Jobs
            </Button>
        </Space>
        <Divider />
    </>
);

export default DebugControls;
